import { Button } from "../ui/button";
import { Card, CardContent, CardFooter, CardHeader } from "../ui/card";
import { Play } from "lucide-react";

interface ContinueLessonProps {
  subtitle: string;
  title: string;
  description: string;
  imageUrl: string;
  onGoToLesson: () => void;
  ctaText?: string;
}

export function ContinueLesson({
  subtitle,
  title,
  description,
  imageUrl,
  onGoToLesson,
  ctaText,
}: ContinueLessonProps) {
  return (
    <Card className="w-full shadow-none border-neutral-50">
      <CardHeader className="relative rounded-t-lg">
        <p className="text-sm text-muted-foreground tracking-tight">
          {subtitle}
        </p>
        <h3 className="text-2xl font-semibold text-neutral-900 tracking-tight">
          {title}
        </h3>
      </CardHeader>
      <CardContent>
        <div className="relative aspect-video rounded-lg">
          <img
            src={imageUrl}
            alt={title}
            className="w-full h-full object-cover rounded-lg"
          />
          <div className="absolute inset-0 flex items-center justify-center">
            <Button
              size="icon"
              className="h-12 w-12 rounded-full bg-white/90 hover:bg-white"
              onClick={onGoToLesson}
            >
              <Play className="h-6 w-6 text-primary" />
            </Button>
          </div>
        </div>
        <p className="mt-4 text-muted-foreground">{description}</p>
      </CardContent>
      <CardFooter>
        <Button onClick={onGoToLesson} className="w-full">
          {ctaText || "Go to Lesson"}
        </Button>
      </CardFooter>
    </Card>
  );
}
